import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Chip} from '@material-ui/core';

const ArchivedStatus = ({isActive, className, isReader}) => (
  <Chip
    label={isReader ? (isActive ? 'Active Subscription' : 'Expired Subscription') : isActive ? 'Active' : 'Archived'}
    className={classNames(className, {
      'background-green': isActive,
      'background-red': !isActive,
    })}
  />
);

ArchivedStatus.propTypes = {
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string,
  isReader: PropTypes.bool.isRequired,
};

ArchivedStatus.defaultProps = {
  isReader: false,
};

export default ArchivedStatus;
